import React from 'react';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';

const useForwardToLicense = (
  isLoading,
  isStartAssessment,
  transactionStatus,
  applicationStatus,
  onYesCallBack,
  onNoCallback = () => {}
) => {
  const isStatusAllowed = ['FOR CHECKING'].indexOf(transactionStatus) > -1;

  const isApplicationStatusAllowed =
    ['FOR PERMIT PROCESS', 'FOR ENDORSING OFFICES ASSESSMENT'].indexOf(
      applicationStatus
    ) > -1;

  const isAllowed = true && isStatusAllowed && isApplicationStatusAllowed;

  const showComponent = isAllowed && isStartAssessment;

  const onHandleClick = (e) => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure, do you want forward to license this application?`,
      onYesCallBack,
      onNoCallback,
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
      // true
    );
  };

  const component = showComponent ? (
    <button
      disabled={isLoading}
      onClick={onHandleClick}
      type="button"
      className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold   "
    >
      {isLoading && (
        <>
          <i className="fas fa-spinner fa-spin" />
          &nbsp;
        </>
      )}
      Forward to License
    </button>
  ) : null;

  return {
    isAllowed,
    onHandleClick,
    component,
  };
};

export default useForwardToLicense;
